import { useTranslation } from "react-i18next";
import AdditionalRegInfo from "../../../../../AdditionalRegInfo/AdditionalRegInfo";
import defaultContent from "../../../../../../../content/profile";
import "./ABOProfileAdditionalInfo.scss";
import { useAppSelector } from "../../../../../../../store";

type Props = {
  orderBlock: boolean;
  sponsorBlock: boolean;
  autoRenewal: boolean;
  contractSigned: boolean;
};

const ABOProfileAdditionalInfo = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const profile = useAppSelector((state) => state.boot?.configuration?.profile);
  const {
    showAutoRenewal,
    showContractSigned,
    showOrderBlock,
    showSponsorBlock,
    displayStatusFormat = "true_false",
  } = profile?.additionalRegInfo || {};

  const { orderBlock, sponsorBlock, autoRenewal, contractSigned } = props;

  const showInfos = [showOrderBlock, showSponsorBlock, showAutoRenewal, showContractSigned];
  const noAdditionalInfo = showInfos.every((showInfo) => showInfo === false);

  if (noAdditionalInfo === true) return <></>;

  return (
    <div className="abo-profile-additional-info">
      <h2 className="abo-profile-additional-info__header">
        {`${t(
          "aboProfile.overviewTab.additionalRegistrationInformation",
          defaultContent["aboProfile"]["overviewTab"]["additionalRegistrationInformation"],
        )}`}
      </h2>
      <div className="abo-profile-additional-info__content">
        <AdditionalRegInfo
          title="orderBlock"
          status={orderBlock}
          show={showOrderBlock}
          labelFormat={displayStatusFormat}
        />
        <AdditionalRegInfo
          title="sponsorBlock"
          status={sponsorBlock}
          show={showSponsorBlock}
          labelFormat={displayStatusFormat}
        />
        <AdditionalRegInfo
          title="autoRenewal"
          status={autoRenewal}
          show={showAutoRenewal}
          labelFormat={displayStatusFormat}
        />
        <AdditionalRegInfo
          title="contractSigned"
          status={contractSigned}
          show={showContractSigned}
          labelFormat={displayStatusFormat}
        />
      </div>
    </div>
  );
};

export default ABOProfileAdditionalInfo;
